import {
  MdOutlineDashboard,
  MdOutlinePerson,
  MdOutlineStorefront,
} from "react-icons/md";
import { FaSquarePlus, FaPersonCircleQuestion } from "react-icons/fa6";
import { AiFillGolden } from "react-icons/ai";
import { RiDeviceRecoverLine } from "react-icons/ri";
import { LuMousePointer2 } from "react-icons/lu";
const sidebarConfig = [
  {
    path: "/console/dashboard",
    icon: <MdOutlineDashboard />,
    text: "டாஷ்போர்டு",
  },
  // {
  //   path: "/console/olddata",
  //   icon: <MdOutlineDashboard />,
  //   text: "Old Record",
  // },
  {
    path: "/console/user",
    icon: <MdOutlinePerson />,
    text: "பயனர் & அணுகல்",
  },
  {
    path: "/console/company",
    icon: <MdOutlineStorefront />,
    text: "நிறுவனம்",
  },
  {
    text: "Master",
    icon: <FaSquarePlus />,
    subMenu: [
      {
        path: "/console/master/group",
        text: "Group",
      },
      // {
      //   path: "/console/master/products",

      //   text: "Products",
      // },
      {
        path: "/console/master/customer",

        text: "Customer",
      },
      // {
      //   path: "/console/master/Street",

      //   text: "Street",
      // },
    ],
  },
  {
    text: "அடகு",
    icon: <AiFillGolden />,
    subMenu: [
      {
        path: "/console/pawn/jewelpawning",
        icon: <AiFillGolden />,
        text: "நகை அடகு",
      },
      // {
      //   path: "/console/pawn/jewelpawng",
      //   icon: <AiFillGolden />,
      //   text: "நகை அடகு - G",
      // },
    ],
  },
  {
    path: "/console/bankpledge",
    text: "Bank Pledge",
    icon: <RiDeviceRecoverLine />,
  },
  {
    path: "/console/interest",
    icon: <LuMousePointer2 />,
    text: "வட்டி",
  },
  {
    text: "மீட்பு",
    icon: <RiDeviceRecoverLine />,
    subMenu: [
      {
        path: "/console/master/jewelrecovery",
        text: "நகை மீட்பு",
      },
      // {
      //   path: "/console/master/jewelrecoveryg",
      //   text: "நகை மீட்பு - G",
      // },
    ],
  },

  {
    path: "/console/expense",
    icon: <FaPersonCircleQuestion />,
    text: "Expenses",
  },
  {
    text: "அறிக்கைகள்",
    icon: <FaSquarePlus />,
    subMenu: [
      {
        path: "/console/report/balancesheet",
        text: "balancesheet DayBook",
      },
      {
        path: "/console/report/bledge",
        text: "Bank Pledge Report",
      },
      {
        path: "/console/report/highvalue",
        text: "High Value Gold Loans",
      },
      // {
      //   path: "/console/report/pawng",
      //   text: "Pawn - G",
      // },
      // {
      //   path: "/console/report/oldrecord",
      //   text: "Old Record",
      // },
    ],
  },
];

export default sidebarConfig;
